import { render, staticRenderFns } from "./CardTab.vue?vue&type=template&id=528e762c&scoped=true&"
import script from "./CardTab.vue?vue&type=script&lang=ts&"
export * from "./CardTab.vue?vue&type=script&lang=ts&"
import style0 from "./CardTab.vue?vue&type=style&index=0&id=528e762c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e762c",
  null
  
)

export default component.exports